import "./style.scss";

const WeatherForecastSummarySkeleton = () => {
	return (
		<div className="weather-forecast-skeleton">
			<div className="visual">
				<div className="icon-visual skeleton" />

				<div className="status-skeleton">
					<div className="line skeleton" />
				</div>

				<div className="temp-div">
					<div className="actual-temp skeleton" />
					<div className="feel skeleton" />
				</div>
			</div>
		</div>
	);
};

export default WeatherForecastSummarySkeleton;
